var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2426 7.75811C18.5858 10.1013 18.5858 13.9002 16.2426 16.2434M7.75736 16.2434C5.41421 13.9002 5.41421 10.1012 7.75736 7.75808M4.92893 19.0718C1.02369 15.1666 1.02369 8.83493 4.92893 4.92969M19.0711 4.92973C22.9763 8.83498 22.9763 15.1666 19.0711 19.0719M14 12.0008C14 13.1053 13.1046 14.0008 12 14.0008C10.8954 14.0008 10 13.1053 10 12.0008C10 10.8962 10.8954 10.0008 12 10.0008C13.1046 10.0008 14 10.8962 14 12.0008Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStream);
export default __webpack_public_path__ + "static/media/live_stream.86161f81cb8edaafc1ec38658d4ab5e4.svg";
export { ForwardRef as ReactComponent };